import React, { createContext, useState, useEffect } from 'react';

// Erstellen des Kontextes
export const GlobalStateContext = createContext();

// Erstellen des Providers   
export const GlobalStateProvider = ({ children }) => {
    const [debugMode, setDebugMode] = useState(localStorage.getItem('debugMode') || false);
    const [previewMode, setPreviewMode] = useState(localStorage.getItem('previewMode') || false);
    const [surveyMode, setSurveyMode] = useState(localStorage.getItem('surveyMode') || '');
    const [debugSaveMode, setDebugSaveMode] = useState(localStorage.getItem('debugSaveMode') || false);
    const [surveyCode, setSurveyCode] = useState(localStorage.getItem('surveyCode') || '');
    const [surveyName, setSurveyName] = useState(localStorage.getItem('surveyName') || '');
    const [surveyId, setSurveyId] = useState(localStorage.getItem('surveyId') || '');
    const [surveyTitle, setSurveyTitle ] = useState(localStorage.getItem('surveyTitle') || '');

    const [participationCode, setParticipationCode ] = useState(JSON.parse(localStorage.getItem('participationCode'))|| '');
    const [questionset_id, setQuestionsetId] = useState(localStorage.getItem('questionset_id') || 0);
    const [completeSet, setCompleteSet] = useState(() => {
        const savedCompleteSet = localStorage.getItem('completeSet');
        try {
            return savedCompleteSet !== null ? JSON.parse(savedCompleteSet) : [];
        } catch (error) {
            console.error("Failed to parse 'completeSet' from localStorage:", error);
            return [];
        }
    });
    const [tokenValid, setTokenValid] = useState(localStorage.getItem('questionset_id') || 0);

    const [participation, setParticipation] = useState(() => {
        const savedParticipation = localStorage.getItem('participation');
        try {
            return savedParticipation !== null ? JSON.parse(savedParticipation) : 'false';
        } catch (error) {
            console.error("Failed to parse 'participation' from localStorage:", error);
            return 'false';
        }
    });
    const [answerSet, setAnswerSet] = useState(() => {
        const savedAnswerSet = localStorage.getItem('answerSet');
        try {
            return savedAnswerSet !== null ? JSON.parse(savedAnswerSet) : [];
        } catch (error) {
            console.error("Failed to parse 'AnswerSet' from localStorage:", error);
            return 'false';
        }
    });
    const [token, setToken] = useState(localStorage.getItem('token') || '');

    // Effekte zum Speichern in localStorage
    useEffect(() => {
        localStorage.setItem('surveyCode', surveyCode);
    }, [surveyCode]);

    useEffect(() => {
      localStorage.setItem('surveyName', surveyName);
  }, [surveyName]);

    useEffect(() => {
      localStorage.setItem('surveyId', surveyId);
  }, [surveyId]);

  useEffect(() => {
    localStorage.setItem('debugSaveMode', debugSaveMode);
}, [debugSaveMode]);

  useEffect(() => {
    localStorage.setItem('previewMode', previewMode);
}, [previewMode]);

  useEffect(() => {
    localStorage.setItem('debugMode', debugMode);
}, [debugMode]);

  useEffect(() => {
    localStorage.setItem('surveyMode', surveyMode);
}, [surveyMode]);

    useEffect(() => {
        localStorage.setItem('surveyTitle', surveyTitle);
  }, [surveyTitle]);

    useEffect(() => {
        localStorage.setItem('questionset_id', questionset_id);
    }, [questionset_id]);

    useEffect(() => {
        localStorage.setItem('completeSet', JSON.stringify(completeSet));
    }, [completeSet]);

    useEffect(() => {
        localStorage.setItem('answerSet', JSON.stringify(answerSet));
    }, [answerSet]);

    useEffect(() => {
        localStorage.setItem('participation', JSON.stringify(participation));
    }, [participation]);

    useEffect(() => {
        localStorage.setItem('participationCode',JSON.stringify(participationCode));
    }, [participationCode]);


    useEffect(() => {
        localStorage.setItem('token', token);
    }, [token]);

    return (
        <GlobalStateContext.Provider value={{ debugMode, setDebugMode, previewMode, setPreviewMode, surveyMode, setSurveyMode, debugSaveMode, setDebugSaveMode, surveyCode, setSurveyCode,  surveyName, setSurveyName, surveyTitle, setSurveyTitle, surveyId, setSurveyId, questionset_id, setQuestionsetId, completeSet, setCompleteSet, participation, setParticipation, answerSet, setAnswerSet, token, setToken, participationCode, setParticipationCode }}>
            {children}
        </GlobalStateContext.Provider>
    );
};